import { useEffect, useRef, useState } from "react";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { useAppSelector } from "store/store";
import DailogEditImageCategories from "../productservicse/dialogProductServicse/DailogEditImageCategories";
import { Sheet, SheetContent } from "components/ui/sheet";
import DailogEditAndAddCategoriesGroup from "../productservicse/dialogProductServicse/DailogEditAndAddCategoriesGroup";
import BtnGoToTop from "components/app/btn-go-to-top/BtnGoToTop";
import PageEditProducts from "../productservicse/dialogProductServicse/PageEditProducts";
import DialogUploadProduct from "../productservicse/dialogProductServicse/DialogUploadProduct";
import ProductAction from "../productservicse/ProductAction";
import ProductServiceTable from "../productservicse/ProductServiceTable";
import ProductServiceCard from "../productservicse/ProductServiceCard";
import ProductServicseNavbarAction from "../productservicse/ProductServicseNavbarAction";
import { useLocation } from "react-router-dom";
import useUrlString from "../useUrlString";
import Status from "../Status";
import ProductItemGroup from "./ProductItemGroup";
export default function ProductService() {
  //*==================Store Glogbal State============================================================================
  const { handleClickUrl, hanleClickRemoveURl } = useUrlString();
  const { btnSearchProduct, btnToggleProduct, indexProductservicse } = useAppSelector((state) => state.header);
  //*===============Function==========================================================================================
  const dataProducts: any = ProductAction();
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("productView", selectedView);
  };
  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      // Deselect all
      dataProducts?.setSelectedProductIds([]);
    } else {
      // Select all
      dataProducts?.setSelectedProductIds(allIds);
    }
  };
  //*===============Variable============================================================================================
  const [view, setView] = useState("card");
  const [defaultDataCategories, setDefaultDataCategories] = useState<boolean>(false);
  const [isDialogOpenEditCategoies, setIsDialogOpenEditCategoies] = useState<boolean>(false);
  const [isDialogOpenEditProducts, setIsDialogOpenEditProducts] = useState<boolean>(false);
  const [editItemCategories, setEditItemCategories] = useState<any>(null);
  const [editItemImageCategories, setEditItemImageCategories] = useState<any>({});
  const [isApiEditAndAddProduct, setIsApiEditAndAddProduct] = useState<boolean>(false);
  const [isDialogEditImageOpen, setIsDialogEditImageOpen] = useState<boolean>(false);
  const [hovered, setHovered] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<any>(null);
  const [isDailogUploadProducts, setIsDailogUploadProducts] = useState<boolean>(false);
  const location = useLocation();
  const allIds = Array.isArray(dataProducts?.productDatas?.data) ? dataProducts?.productDatas?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => dataProducts?.selectedProductIds.includes(id));
  //*===============Ueffect==============================================================================================
  useEffect(() => {
    if (listRef.current && dataProducts?.productLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      dataProducts?.fetchMoreUserShopProduct({
        next: dataProducts?.productLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataProducts?.productDatas?.data]);
  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", dataProducts?.handleScroll);
    }
    return () => {
      if (container) container.removeEventListener("scroll", dataProducts?.handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    dataProducts?.initUserShopProduct();
    const savedView = localStorage.getItem("productView");
    if (savedView) {
      setView(savedView);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataProducts?.searchTextInput, dataProducts?.selectedProductGroupCode, btnToggleProduct, btnSearchProduct]);
  useEffect(() => {
    dataProducts?.initCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const requestId: any = url.get("product_id");
    if (requestId) {
      (async () => {
        dataProducts?.setOpenPopoverIndex(1);
        dataProducts?.getShopProductDetail(requestId);
        dataProducts?.setDefaultDataProduct(true);
        dataProducts?.setId(requestId);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ====================Prop==============================================================================================
  const productServiceNavbarActionProp = {
    selectProducts: dataProducts?.selectProducts,
    selectedProductIds: dataProducts?.selectedProductIds,
    allIds: allIds,
    setOpenPopoverIndex: dataProducts?.setOpenPopoverIndex,
    setEditItemShopProduct: dataProducts?.setEditItemShopProduct,
    setIsApiEditAndAddProduct: setIsApiEditAndAddProduct,
    selectedProductGroupCode: dataProducts?.selectedProductGroupCode,
    itemGroups: dataProducts?.itemGroups,
    setId: dataProducts?.setId,
    setIsDialogOpenEditCategoies: setIsDialogOpenEditCategoies,
    onSubmitDeleteProdcuts: dataProducts?.onSubmitDeleteProdcuts,
    submitUndoDeleteShopProduct: dataProducts?.submitUndoDeleteShopProduct,
    setSelectProducts: dataProducts?.setSelectProducts,
    isAllSelected: isAllSelected,
    handleToggleSelectAll: handleToggleSelectAll,
    setSelectedProductIds: dataProducts?.setSelectedProductIds,
    handlePrint: dataProducts?.handlePrint,
    loadingPrint: dataProducts?.loadingPrint,
    setSearchTextInput: dataProducts?.setSearchTextInput,
    view: view,
    changeView: changeView,
  };
  const productItemGroupProp = {
    containerRef: containerRef,
    setHovered: setHovered,
    hovered: hovered,
    setIsDialogOpenEditCategoies: setIsDialogOpenEditCategoies,
    setDefaultDataCategories: setDefaultDataCategories,
    setEditItemCategories: setEditItemCategories,
    setSelectedProductGroupCode: dataProducts?.setSelectedProductGroupCode,
    handleClickCategory: dataProducts?.handleClickCategory,
    selectedProductGroupCode: dataProducts?.selectedProductGroupCode,
    itemGroups: dataProducts?.itemGroups,
    loadingFetchDataCategoires: dataProducts?.loadingFetchDataCategoires,
    setId: dataProducts?.setId,
    setItemGroups: dataProducts?.setItemGroups,
  };
  const productCardProp = {
    handleClickUrl: handleClickUrl,
    listRef: listRef,
    productDatas: dataProducts?.productDatas,
    productLoading: dataProducts?.productLoading,
    loadingFetchDataProducts: dataProducts?.loadingFetchDataProducts,
    fetchMoreUserShopProduct: dataProducts?.fetchMoreUserShopProduct,
    setDefaultDataProduct: dataProducts?.setDefaultDataProduct,
    getShopProductDetail: dataProducts?.getShopProductDetail,
    setOpenPopoverIndex: dataProducts?.setOpenPopoverIndex,
    setId: dataProducts?.setId,
    selectProducts: dataProducts?.selectProducts,
    setSelectedProductIds: dataProducts?.setSelectedProductIds,
    selectedProductIds: dataProducts?.selectedProductIds,
    setProductDatas: dataProducts?.setProductDatas,
    indexProductservicse: indexProductservicse,
  };
  const productTable = {
    handleClickUrl: handleClickUrl,
    listRef: listRef,
    productDatas: dataProducts?.productDatas,
    productLoading: dataProducts?.productLoading,
    loadingFetchDataProducts: dataProducts?.loadingFetchDataProducts,
    fetchMoreUserShopProduct: dataProducts?.fetchMoreUserShopProduct,
    setDefaultDataProduct: dataProducts?.setDefaultDataProduct,
    getShopProductDetail: dataProducts?.getShopProductDetail,
    setOpenPopoverIndex: dataProducts?.setOpenPopoverIndex,
    setId: dataProducts?.setId,
    selectProducts: dataProducts?.selectProducts,
    setSelectedProductIds: dataProducts?.setSelectedProductIds,
    selectedProductIds: dataProducts?.selectedProductIds,
    setProductDatas: dataProducts?.setProductDatas,
  };
  const categoriesGroupProp = {
    editItemCategories: editItemCategories,
    setEditItemCategories: setEditItemCategories,
    isDialogOpenEditCategoies: isDialogOpenEditCategoies,
    setIsDialogOpenEditCategoies: setIsDialogOpenEditCategoies,
    defaultDataCategories: defaultDataCategories,
    itemPrinter: dataProducts?.itemPrinter,
    setItemPrinter: dataProducts?.setItemPrinter,
  };
  const pageEditProductProp = {
    setIsDailogUploadProducts: setIsDailogUploadProducts,
    setOpenPopoverIndex: dataProducts?.setOpenPopoverIndex,
    setProductDatas: dataProducts?.setProductDatas,
    editItemCategories: editItemCategories,
    editItemShopProduct: dataProducts?.editItemShopProduct,
    setEditItemShopProduct: dataProducts?.setEditItemShopProduct,
    isDialogOpenEditProducts: isDialogOpenEditProducts,
    setIsDialogOpenEditProducts: setIsDialogOpenEditProducts,
    isApiEditAndAddProduct: isApiEditAndAddProduct,
    setIsApiEditAndAddProduct: setIsApiEditAndAddProduct,
    itemGroups: dataProducts?.itemGroups,
    id: dataProducts?.id,
    setId: dataProducts?.setId,
    defaultDataProduct: dataProducts?.defaultDataProduct,
    loadingFetchDataProductDetail: dataProducts?.loadingFetchDataProductDetail,
  };
  const dialogUploadImageProductProp = {
    setProductDatas: dataProducts?.setProductDatas,
    editItemCategories: editItemCategories,
    itemGroups: dataProducts?.itemGroups,
    isDailogUploadProducts: isDailogUploadProducts,
    setIsDailogUploadProducts: setIsDailogUploadProducts,
    setIsDialogOpenEditProducts: setIsDialogOpenEditProducts,
  };
  // =====================================================Product Servicse View=============================================

  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="lg:w-auto md:w-auto w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm ">Product & Services</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Seamless Setup for Maximum Marketplace Visibility</p>
          </div>
          {dataProducts?.warning ? "" : <ProductServicseNavbarAction {...productServiceNavbarActionProp} />}
        </div>
        {dataProducts?.warning ? (
          ""
        ) : (
          <>
            <ProductItemGroup {...productItemGroupProp} />
          </>
        )}
      </div>
      {dataProducts?.warning ? (
        <Status className="h-[70vh]" errorStatus={dataProducts?.errorStatus} />
      ) : (
        <div className="pb-3 h-full mt-5  ">
          {view === "card" ? (
            <>
              <ProductServiceCard {...productCardProp} />
            </>
          ) : (
            // list Table
            <>
              <ProductServiceTable {...productTable} />
            </>
          )}
        </div>
      )}

      <DailogEditAndAddCategoriesGroup
        onUploadSuccess={({ res, name }) => {
          if (name === "delete") {
            dataProducts?.setItemGroups((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => item.id !== res.id),
              };
            });

            dataProducts?.handleClickCategory({
              categoryName: "All",
              groupId: "",
            });
          } else {
            dataProducts?.setItemGroups((prevItemGroups: any) => {
              const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
              const exists = updatedData.some((item: any) => item.id === res.id);
              if (!exists) {
                updatedData.push(res);
              }
              return {
                ...prevItemGroups,
                data: updatedData,
              };
            });
          }
        }}
        {...categoriesGroupProp}
      />

      <DailogEditImageCategories
        editItemImageCategories={editItemImageCategories}
        isDialogEditImageOpen={isDialogEditImageOpen}
        setIsDialogEditImageOpen={setIsDialogEditImageOpen}
      />

      <BtnGoToTop />

      <Sheet
        open={dataProducts?.openPopoverIndex === 1}
        onOpenChange={(isOpen) => {
          dataProducts?.setOpenPopoverIndex(isOpen ? 1 : null);
          setIsApiEditAndAddProduct(false);
          if (!isOpen) {
            hanleClickRemoveURl("product_id");
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[1000px] justify-between p-3 pt-[50px]">
          <PageEditProducts
            onUploadSuccess={({ res, name }) => {
              if (name === "delete") {
                dataProducts?.setProductDatas((prevItemGroups: any) => {
                  return {
                    ...prevItemGroups,
                    data: (prevItemGroups.data || []).filter((item: any) => item.id !== res.id),
                  };
                });
              } else {
                dataProducts?.setProductDatas((prevItemGroups: any) => {
                  const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                  const exists = updatedData.some((item: any) => item.id === res.id);
                  if (!exists) {
                    updatedData.push(res);
                  }
                  return {
                    ...prevItemGroups,
                    data: updatedData,
                  };
                });
              }
            }}
            {...pageEditProductProp}
          />
        </SheetContent>
      </Sheet>
      <DialogUploadProduct {...dialogUploadImageProductProp} />
    </BusinessSuiteContentLayout>
  );
}
